import { Action } from "~/modules/actions/Action";
import { CbmImpl } from "~/modules/cbm/CbmImpl";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { createFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { getLogger } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { sendWorkerTrackingEvent, toCauseMessage } from "~/modules/telemetry/utils";
import { findSupervisorOnCall } from "~/modules/actions/ActionUtils";





























export class BargeCall implements Action<Promise<void>> {
    readonly #taskSid: string;

    



    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}): Promise<void> {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();

        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const logger = getLogger(context)("BargeCall");
        const worker = taskRouter.worker;

        const checkUtils = {
            actionName: "BargeCall",
            moduleName: "actions/Voice",
            context,
            analytics,
            logger,
            worker,
            event: EVENTS.BargeCallCompleted,
            extra: { taskSid: this.#taskSid }
        };

        try {
            const task = await taskRouter.workspace.fetchTask(this.#taskSid);
            const participants = await cbm.getParticipantsByTask(task);

            const supervisor = findSupervisorOnCall(participants, this.#taskSid, checkUtils);

            await cbm.modifyVoiceParticipant(task, supervisor.participantSid, {
                muted: false,
                coaching: false
            });

            sendWorkerTrackingEvent(EVENTS.BargeCallCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                supervisorParticipantSid: supervisor.participantSid
            });
        } catch (error: unknown) {
            const errorMsg = `BargeCall: Failed to barge call for task ${this.#taskSid}`;
            logger.error(errorMsg, error);
            sendWorkerTrackingEvent(EVENTS.BargeCallCompleted, analytics, worker, {
                error: `${errorMsg} (${toCauseMessage(error)})`,
                taskSid: this.#taskSid
            });
            throw createFlexSdkError(context)(
                ErrorCode.FailedToBargeCall,
                { severity: ErrorSeverity.Error },
                errorMsg,
                error as Error
            );
        }
    }
}
